import React from "react";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { Card, CardContent, Typography, Box } from "@mui/material";
import UploadCollectionCard from "./UploadCollectionCard";
import UploadBrowseCard from "./UploadBrowseCard";

const UploadCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    return (
        <Card sx={{  width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0  }}>
            <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, my: 1, }}>
                        <UploadCollectionCard uploadType="user" />
                        <UploadCollectionCard uploadType="staff" />
                        <UploadBrowseCard />
                    </Box>
            </CardContent>
        </Card>
    );
};

export default UploadCard;
